/**
 * KpiCard — presentational stat tile: a label, a value, and an optional hint. The value carries
 * the theme's `kpi` variant (24 / 30 at 600, TMM-T2), which carries the tabular numerals (TYPE-006)
 * the `numeric` token and `Amount` use.
 */
import { Paper, Typography } from '@mui/material';

interface KpiCardProps {
  label: string;
  value: string | number;
  hint?: string;
  /** Opt-in headline treatment for a primary metric. */
  valueVariant?: 'kpi' | 'h1' | 'h2';
}

export function KpiCard({ label, value, hint, valueVariant = 'kpi' }: KpiCardProps) {
  return (
    <Paper variant="outlined" sx={{ p: 2, minWidth: 160 }}>
      <Typography
        variant="caption"
        component="p"
        sx={{ color: 'text.secondary', letterSpacing: '0.02em' }}
      >
        {label}
      </Typography>
      <Typography
        variant={valueVariant}
        component="p"
        sx={(theme) => ({ ...theme.typography.numeric, mt: 0.5, mb: hint ? 0.25 : 0 })}
      >
        {value}
      </Typography>
      {hint ? (
        <Typography variant="caption" component="p" sx={{ color: 'text.secondary' }}>
          {hint}
        </Typography>
      ) : null}
    </Paper>
  );
}
